import __ from "src/utils/Translations";
import {
  chargeAccount,
  dischargeAccount,
  ahrChargeAccount,
  ahrDischargeAccount,
} from "src/Pages/Company/api/pointsBanks/clients";

type ChargeOrDischargeOptions = {
  isAhr: boolean;
  principalId: string;
  employeeId: string;
};

export const chargeOrDischarge = (
  accountId: string,
  amount: number,
  { isAhr, principalId, employeeId }: ChargeOrDischargeOptions
): Promise<void> => {
  if (amount === 0) {
    return Promise.reject(new Error(__("Kwota operacji nie może wynosić 0.")));
  }

  const absAmount = Math.abs(amount);

  if (isAhr) {
    return amount < 0
      ? ahrDischargeAccount(accountId, absAmount, employeeId)
      : ahrChargeAccount(accountId, absAmount, employeeId);
  }

  return amount < 0
    ? dischargeAccount(accountId, absAmount, principalId)
    : chargeAccount(accountId, absAmount, principalId);
};
